import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson=()=>{
  let initData:any={
    table:"eval_form",
    list_id:"eval_form_list",
    x_column_list_arr:[
      // {"key":"row_view_manage","name":"관리","width":"80","is_show":"1"},
      {"key":"a_title","name":"제목","width":"100","is_show":"1"},
      {"key":"a_subject","name":"과목","width":"100","is_show":"1"},
      {"key":"a_writer_name","name":"작성자","width":"100","is_show":"1"},
      {"key":"a_create_date","name":"작성일","width":"140","is_show":"1"},
    ],
    list_opt_origin:{
      'now_page':1,
      'num_per_page':100,
      'order_id':'a_title',
      'order_type':'',
      's_date_type':'',
      's_start_date':'',
      's_end_date':'',
      'sc':{},
      "is_add_idx_info":"1",
    },
    order_id_col_arr:[
      {"value":"","text":"없음"},
    ]
  };
  initData.pri_col_arr=["a_seq"];
  const xColumnArr:any=XcolumnFunc.getDefaultXcolumn(initData);
  if(xColumnArr.select_arr.a_subject==undefined){
    xColumnArr.select_arr.a_subject=[];
  }

  return xColumnArr;
};

export default getXcolumnJson;